import { useEffect, useState } from "react";
import { fetchFleetState } from "../api/opsApi";

// Whether the fleet page is switched on, and the words it should show.
//
// `enabled` is null until the answer is in, so a caller can tell "not yet known" from "off"
// and avoid flashing a redirect before it has asked. A failed read reads as off: a page that
// has been taken down must not reappear because an API was unreachable.
export default function useFleetState() {
  const [state, setState] = useState({ enabled: null, content: null });

  useEffect(() => {
    const controller = new AbortController();
    fetchFleetState({ signal: controller.signal })
      .then(setState)
      .catch((error) => {
        if (error.name !== "AbortError") setState({ enabled: false, content: null });
      });
    return () => controller.abort();
  }, []);

  return state;
}
